/**
* @author Camilo
* @since  08/11/2017
**/
export class LoginModel{
	constructor(public usuario:string, public clave:string, public empresa:string, public comfirmClave:string, public codigoConfirmacion:string){
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/forgot-password-2/Login.model.ts